import {Controller} from "stimulus"
import Splide from "@splidejs/splide"

export default class extends Controller {


    static targets = [
        "item",
        "modal",
        "container"
    ]

    initialize() {
        let options = {
            speed: 1200,
            perPage: 1,
            type: 'fade', //slide | loop | fade
            gap: 0,
            pagination: false,
            autoplay: false,
            arrows: false,
            slideFocus: false, //INDEX
            easing: 'cubic-bezier(.42,.65,.27,.99)',
        }

        options = Object.assign({}, options, this.options)

        const splide = new Splide( ".splide1", options).mount();

        splide.on( 'move', (index)=> {
            index = index + 1
            this.pagination(index)
        })


        const elements = document.querySelectorAll('.splide2')

        elements.forEach( element =>{
            new Splide( element,{
                arrows: false,
                type: 'fade',
                autoplay: true,
                interval: 5000,
                drag: false,
                pagination: false,
                rewind: true,
                speed: 1200,
                easing: 'cubic-bezier(.42,.65,.27,.99)',
            }).mount();
        })
    }


    //Utils
    get options() {
        const options = this.data.get("options")
        return options ? JSON.parse(options) : {}
    }

    pagination(index){
        const pagination = document.querySelector('.js-splide-pagination')
        pagination.textContent=index
    }
}